<template>
    <!-- <q-layout view="hHh lpR fFf"> -->
    <q-layout style="overflow-y: hidden">
        <!-- <q-ajax-bar ref=" bar" size="5px" :delay="delay" /> -->
        <!-- <StudyHeader v-if="menuMeta?.header === true" /> -->
        <router-view />
        <!-- <alertDialog v-if="alertOption.open" /> -->
        <!-- <confirmDialog v-if="confirmOption.open" /> -->
        <alertDialog />
        <confirmDialog />
    </q-layout>

    <!-- <div class="loading" v-if="visibleLoading"></div> -->
</template>

<script>
import { computed, ref } from 'vue';
// import { useStore } from 'vuex';
import { DialogStore } from '@/store/modules/dialog';
import { AuthStore } from '@/store/modules/auth';
import { GlobalStore } from '@/store';
import alertDialog from '@/components/layouts/dialog/alertDialog';
import confirmDialog from '@/components/layouts/dialog/confirmDialog';
import StudyHeader from './components/layouts/header/studyHeader.vue';
import { useQuasar } from 'quasar';

import { checkServiceApi } from '@/api/modules/login';

const setScreenSize = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};
const $q = useQuasar();
// let visibleLoading = ref(true);

window.removeEventListener('click', setScreenSize);
window.addEventListener('resize', setScreenSize);

// document.addEventListener('visibilitychange', () => {
//     if (document.visibilityState === 'visible') {
//         visibleLoading.value = false;
//     }
// });
// onMounted(() => {
//     visibleLoading.value = false;
// });

export default {
    name: 'app',
    components: {
        alertDialog,
        confirmDialog,
        // StudyHeader,
    },
    setup() {
        const delay = 0;
        const store = DialogStore();
        const authStore = AuthStore();
        const gStore = GlobalStore();

        const menuMeta = computed(() => authStore.menuMeta);
        // const alertOption = computed(() => store.alertOption);
        // const confirmOption = computed(
        //     () => store.confirmOption,
        // );
        const onStartAjaxBar = () => {
            this.$refs.bar.start();
        };
        const onStopAjaxBar = () => {
            this.$refs.bar.stop();
        };
        setScreenSize();

        //실시간 중복 로그인을 위해 넣음...
        //앱에서 와이파이 신호가 약할 시 지속적인 통신 장애가 발생
        //실시간 체크로직 제외
        /*
        setInterval(() => {
            console.log('check token');
            if (gStore.token && !gStore.isRefreshingToken) checkServiceApi();
        }, 5000);
        */

        return {
            delay,
            onStartAjaxBar,
            onStopAjaxBar,
            menuMeta,
            // confirmOption,
            // alertOption,
        };
    },
};
</script>

<style lang="scss" scoped>
// .loading {
//     position: absolute;
//     top: 50%;
//     left: 0;
//     right: 0;
//     z-index: 100;
//     height: 60px;
//     width: 60px;
//     margin: -30px auto 0;
//     border: 6px solid $primary;
//     border: {
//         right-color: $gray_400;
//         top-color: $gray_400;
//         radius: 100%;
//     }
//     animation: spin 800ms infinite linear;
//     @include center-element;
// }

// @keyframes spin {
//     from {
//         transform: rotate(0deg);
//     }
//     to {
//         transform: rotate(359deg);
//     }
// }
//
</style>
